// useElementHandlers.js

import { useCallback } from 'react';

export function useElementHandlers(elements, setElements, setGuides, selectedId, setSelectedId, editingText, setEditingText) {
  const handleChange = useCallback((field, value) => {
    setElements(elements.map(el => el.id === selectedId ? { ...el, [field]: value } : el));
  }, [elements, selectedId, setElements]);

  const handleTextChange = useCallback((e) => {
    setElements(elements.map(el => el.id === editingText.id ? { ...el, text: e.target.value } : el));
  }, [elements, editingText, setElements]);

  const handleTextBlur = useCallback(() => {
    setEditingText(null);
  }, [setEditingText]);

  const handleDrag = useCallback((id, e) => {
    const dragged = { ...elements.find(el => el.id === id), x: e.target.x(), y: e.target.y() };
    const newGuides = [];
    elements.forEach(el => {
      if (el.id === id) return;
      if (Math.abs(el.x - dragged.x) < 5) newGuides.push({ points: [el.x, 0, el.x, 1056] });
      if (Math.abs(el.y - dragged.y) < 5) newGuides.push({ points: [0, el.y, 816, el.y] });
    });
    setGuides(newGuides);
    setElements(elements.map(el => el.id === id ? { ...el, x: dragged.x, y: dragged.y } : el));
  }, [elements, setElements, setGuides]);

  const handleDoubleClick = useCallback((el) => {
    if (el.type === 'text' || el.type === 'checkbox') setEditingText({ ...el });
  }, [setEditingText]);

  return {
    handleChange,
    handleTextChange,
    handleTextBlur,
    handleDrag,
    handleDoubleClick,
  };
}
